import {getTestProps} from '@benchling/js-test-utils';
import {Modal, Stack, Text, createStyles} from '@mantine/core';
import React from 'react';

import {isNodeTesting} from 'lib/Browser';
import {SkillSummary} from 'llm/chat-library/skills/SkillsDAO';

export interface SkillDetailModalProps {
  skill: SkillSummary | null;
  opened: boolean;
  onClose: () => void;
}

export default function SkillDetailModal(props: SkillDetailModalProps): JSX.Element {
  const {skill, opened, onClose} = props;
  const {classes} = useStyles();

  return (
    <Modal
      {...getTestProps({component: 'SkillDetailModal', element: 'root'})}
      opened={opened && skill != null}
      onClose={onClose}
      title={skill?.name ?? ''}
      size="lg"
      closeOnClickOutside={true}
      closeOnEscape={true}
      withinPortal={!isNodeTesting}
      zIndex={1040}
    >
      {skill != null && (
        <Stack spacing="sm">
          {skill.creatorName != null && skill.creatorName !== '' && (
            <Text className={classes.meta}>by {skill.creatorName}</Text>
          )}
          {skill.createdAt != null && skill.createdAt !== '' && (
            <Text className={classes.meta}>Created {new Date(skill.createdAt).toLocaleDateString()}</Text>
          )}
          <Text className={classes.description} size="sm">
            {skill.description}
          </Text>
        </Stack>
      )}
    </Modal>
  );
}

const useStyles = createStyles((theme) => ({
  description: {
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
  },
  meta: {
    color: theme.colors.gray[6],
    fontSize: theme.fontSizes.sm,
  },
}));
